


const Footer = () => {
    return (
        <>
            <section className="footer comic-neue-bold">
                <h3>Created By Vikesh Gaikwad || Last Updated 13th Feb 2024 || Stay tuned with me</h3>
            </section>
        </>
    )
}



export default Footer;